import {useQuoteContext} from "../../../contexts/QuoteContext";
import {Alert} from "antd";
import ReviseQuoteButton from "../ReviseQuoteButton";
import React from "react";

const AlertExpired = (props: {
    onReviseQuote: () => void;
}) => {

    const { quote} = useQuoteContext();

    if ( !(quote && quote.expired) ) return <></>

    return <div style={{marginBottom: "1rem"}}>
        <Alert
            type="error"
            message={<div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>This quote has expired. <ReviseQuoteButton onClick={props.onReviseQuote} style={{marginRight: "1rem"}}>Revise Quote</ReviseQuoteButton></div>}
            closable={true}
        />
    </div>
}

export default AlertExpired;
